<template>
  <div>
    <v-text-field
      :autoid="autoid"
      type="text"
      v-model="dataItem"
      height="42"
      class="add-ipaddress"
      :label="displayName"
      autocomplete="false"
      outlined
      append-icon="add_circle_outline"
      @click:append="addItemtoList($event)"
      @keypress="addItemtoList($event)"
      @blur="checkOnBlur"
      data-vv-validate-on="change"
      :disabled="isMaxListCount"
      :hint="disabledHintText"
      :persistent-hint="showFieldDisabledHint"
      v-validate="validationRule"
      :data-vv-as="displayName"
      :data-vv-name="key"
      :error-messages="errors.collect(key)"
      :key="key"
      :ref="refId"
    ></v-text-field>
    <div class="data-list-cnr">
      <div class="data-list-item" v-for="(item, index) in dataList" :key="index">
        <span x-ms-format-detection="none">{{ item }}</span>
        <v-btn
          autoid="btn-remove-ip-address"
          text
          icon
          color="blue"
          :key="index"
          @click="deleteItemFromList(index)"
        >
          <v-icon>remove_circle_outline</v-icon>
        </v-btn>
      </div>
    </div>
    <div style="display: none">{{ipAddressError}}</div>
  </div>
</template>

<script>
export default {
  name: 'yAddListItem',
  inject: ['$validator'],
  data() {
    return {
      dataItem: '',
      listcount: this.listCounter,
      evt: '',
      dataList: this.dataListProps.defaultValue,
      maxListCount: this.dataListProps.maxListCount,
      displayName: this.dataListProps.displayName,
      validationRule: this.dataListProps.validationRule,
      autoid: this.dataListProps.autoid,
      key: this.dataListProps.key,
      refId: this.dataListProps.refId,
      isRequired: this.dataListProps.isRequired,
      showError: this.dataListProps.showError
    }
  },
  props: {
    dataListProps: Object
  },
  created() {
    this.dataListProps.showError = false
  },
  computed: {
    ipAddressError() {
      if (this.dataListProps.showError) {
        this.checkOnBlur()
      }
      return this.dataListProps.showError
    },
    listCounter() {
      return this.dataList.length
    },
    isMaxListCount() {
      if (parseInt(this.maxListCount) === this.listCounter) {
        return true
      } else {
        return false
      }
    },
    disabledHintText() {
      if (parseInt(this.maxListCount) === this.listCounter) {
        return 'You have added maximum number of items.'
      } else {
        return ''
      }
    },
    showFieldDisabledHint() {
      if (parseInt(this.maxListCount) === this.listCounter) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    addItemtoList(evt) {
      if (evt.type === 'keypress' && evt.keyCode !== 13) {
        return
      }
      if (!this.dataItem) {
        return
      }
      var _self = this
      _self.$validator.validate(_self.key, _self.dataItem).then(result => {
        if (result) {
          if (-1 === _self.dataList.indexOf(_self.dataItem)) {
            _self.dataList.push(_self.dataItem)
            _self.listcount++
            _self.dataItem = ''
            let field = _self.key
            _self.errors.remove(field)
            _self.dataListProps.showError = false
          } else {
            let msg =
              'Already exists! Please enter a different ' +
              _self.displayName +
              '.'
            let field = _self.key
            _self.errors.add({
              field,
              msg
            })
            _self.dataListProps.showError = true
          }
        }
      })
    },
    deleteItemFromList(index) {
      this.dataList.splice(index, 1)
      this.listcount--
      if (this.dataList.length <= 0) {
        this.$refs[this.refId].focus()
      }
    },
    checkOnBlur() {
      if (!this.dataList.length && this.isRequired) {
        var msg = 'Required field.'
        var field = this.key
        this.errors.add({
          field,
          msg
        })
        this.dataListProps.showError = true
      }
    }
  }
}
</script>

<style>
.data-list-cnr {
  margin-top: 0px;
  margin-bottom: 16px;
}

.data-list-cnr .data-list-item {
  padding-left: 12px;
  text-align: left;
  height: 32px;
  margin-bottom: 4px;
  background-color: #f0f0f0;
  border-radius: 4px;
}

.data-list-cnr .data-list-item:last-child {
  margin-bottom: 36px;
}

.data-list-cnr .data-list-item > span {
  vertical-align: middle;
  width: 200px;
  float: left;
  height: 32px;
  line-height: 32px;
}

.data-list-cnr .data-list-item .v-btn__content i {
  font-size: 18px;
  color: #dc3828;
}

.data-list-cnr .data-list-item button {
  margin-left: 16px;
  float: right;
  height: 32px;
}

.v-input.add-ipaddress .v-icon.v-icon.v-icon--link {
  cursor: default !important;
}
.v-input.add-ipaddress.primary--text .v-icon.v-icon.v-icon--link {
  cursor: pointer !important;
}
.v-input.add-ipaddress.error--text .v-icon.v-icon.v-icon--link {
  cursor: pointer !important;
}
.v-input.add-ipaddress.v-input--is-label-active .v-icon.v-icon.v-icon--link {
  cursor: pointer !important;
}


</style>
